import React, { useState } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
	useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import PlanTable from "./components/PlanTable";
import CustomerTable from "./components/CustomerTable";
import TransactionHistory from "./components/TransactionHistory";
import TransactionFlow from "./components/TransactionFlow";
import ConnectionDetails from "./components/ConnectionDetails";
import CustomerDetails from "./components/CustomerDetails";
import LoginForm from "./components/LoginForm";
import SignUp from "./components/SignUp"; // Import SignUp Component
import Dashboard from "./components/Dashboard"; // Import the Dashboard component
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { UserProvider } from "./contexts/UserContext";

const SIDEBAR_WIDTH = "220px";

const AppLayout = ({ children }) => {
	const location = useLocation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

	const toggleSidebar = () => {
		setSidebarOpen(!sidebarOpen);
	};

	const isLoginPage =
		location.pathname === "/login" || location.pathname === "/signup"; // Also hide Sidebar & Navbar for SignUp

	return (
		<Box>
			{!isLoginPage && <Navbar toggleSidebar={toggleSidebar} />}
			<Box display="flex" pt={!isLoginPage ? "64px" : "0"}>
				{!isLoginPage && (!isMobile || sidebarOpen) && <Sidebar />}
				<Box
					component="main"
					flexGrow={1}
					p={!isLoginPage ? 3 : 0}
					ml={!isLoginPage && (!isMobile || sidebarOpen) ? SIDEBAR_WIDTH : 0}
					sx={{
						width:
							!isLoginPage && (!isMobile || sidebarOpen)
								? `calc(100% - ${SIDEBAR_WIDTH})`
								: "100%",
						minHeight: "100vh",
						transition: "margin-left 0.3s ease",
					}}
				>
					{children}
				</Box>
			</Box>
		</Box>
	);
};

const App = () => {
	return (
		<UserProvider>
			<Router>
				<AppLayout>
					<Routes>
						{/* Redirect root to login page */}
						<Route path="/" element={<Navigate to="/login" replace />} />

						{/* Login Page */}
						<Route
							path="/login"
							element={
								<Box
									display="flex"
									justifyContent="center"
									alignItems="center"
									height="100vh"
								>
									<LoginForm />
								</Box>
							}
						/>

						{/* Sign Up Page */}
						<Route
							path="/signup"
							element={
								<Box
									display="flex"
									justifyContent="center"
									alignItems="center"
									height="100vh"
								>
									<SignUp />
								</Box>
							}
						/>

						{/* Customer Management Page */}
						<Route
							path="/customer-management"
							element={
								<>
									<Typography variant="h6" fontWeight="bold" gutterBottom>
										Customer Management
									</Typography>
									<CustomerTable />
								</>
							}
						/>

						{/* Customer Details Page */}
						<Route
							path="/customer-details"
							element={
								<>
									<Typography variant="h6" fontWeight="bold" gutterBottom>
										Customer Details
									</Typography>
									<CustomerDetails />
								</>
							}
						/>

						{/* Plan Management Page */}
						<Route
							path="/plan-management"
							element={
								<>
									<Typography variant="h6" fontWeight="bold" gutterBottom>
										Plan Management
									</Typography>
									<PlanTable />
								</>
							}
						/>

						{/* Connection Details Page */}
						<Route
							path="/connection-details"
							element={
								<>
									<Typography variant="h6" fontWeight="bold" gutterBottom>
										Connection Details
									</Typography>
									<ConnectionDetails />
								</>
							}
						/>

						{/* Dashboard Page */}
						{/* <Route path="/dashboard" element={<Dashboard />} /> */}
						<Route
							path="/dashboard"
							element={
								<>
									<Typography variant="h6" fontWeight="bold" gutterBottom>
										Dashboard
									</Typography>
									<Dashboard />
								</>
							}
						/>

						{/* Transactions Page */}
						<Route path="/transactions" element={<TransactionHistory />} />

						{/* Transaction Flow Page */}
						<Route path="/transaction-flow" element={<TransactionFlow />} />
					</Routes>
				</AppLayout>
			</Router>
		</UserProvider>
	);
};

export default App;
